import { useTranslation } from 'react-i18next';
import KpiCard from './KpiCard';
import { useDashboardKpis } from './useDashboardKpis';
import { useKpiPeriod } from './useKpiPeriod';
import PeriodToggle from './PeriodToggle';

function ClockIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export default function UtilizationWidget() {
  const { t } = useTranslation();
  const { data, loading } = useDashboardKpis();
  const [period, setPeriod] = useKpiPeriod('utilization');

  const pct = data == null
    ? 0
    : period === 'total' ? data.utilization_total : data.utilization_30d;

  const direction: 'up' | 'down' | 'neutral' = pct >= 70 ? 'up' : pct >= 40 ? 'neutral' : 'down';
  const caption = pct >= 70
    ? t('dashboard.kpi_util_good', { defaultValue: 'God udnyttelse' })
    : pct >= 40
    ? t('dashboard.kpi_util_ok', { defaultValue: 'Moderat udnyttelse' })
    : t('dashboard.kpi_util_low', { defaultValue: 'Lav udnyttelse' });

  return (
    <KpiCard
      label={
        <span className="inline-flex items-center gap-2">
          <span>{t('dashboard.kpi_utilization', { defaultValue: 'Udnyttelse' })}</span>
          <PeriodToggle value={period} onChange={setPeriod} />
        </span>
      }
      value={pct}
      unit="%"
      icon={<ClockIcon />}
      iconTone="sage"
      delta={data ? { label: caption, direction } : undefined}
      loading={loading}
    />
  );
}
